import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Wrench, Instagram, Facebook, Music2 } from "lucide-react";
import { useLang } from "@/i18n";
import { GARAGE } from "@/config";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer data-testid="site-footer" className="bg-[#0A0A0C] border-t border-zinc-800 mt-16">
      <div className="container-x py-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-2 mb-4">
            {GARAGE.logoUrl ? (
              <img src={GARAGE.logoUrl} alt="Milano Worx" className="h-9 w-auto" />
            ) : (
              <div className="w-8 h-8 rounded-lg bg-[#E11D48] flex items-center justify-center">
                <Wrench size={15} className="text-white" />
              </div>
            )}
            <span className="font-heading font-extrabold text-white">MILANO <span className="text-[#E11D48]">WORX</span></span>
          </div>
          <p className="text-sm text-zinc-400">{t("footer.tag")}</p>
          <div className="flex gap-3 mt-4">
            <a href={GARAGE.instagram} target="_blank" rel="noreferrer" data-testid="social-instagram" className="p-2 rounded-lg bg-white/5 text-zinc-400 hover:text-[#E11D48] transition-colors"><Instagram size={18} /></a>
            <a href={GARAGE.tiktok} target="_blank" rel="noreferrer" data-testid="social-tiktok" className="p-2 rounded-lg bg-white/5 text-zinc-400 hover:text-[#E11D48] transition-colors"><Music2 size={18} /></a>
            <a href={GARAGE.facebook} target="_blank" rel="noreferrer" data-testid="social-facebook" className="p-2 rounded-lg bg-white/5 text-zinc-400 hover:text-[#E11D48] transition-colors"><Facebook size={18} /></a>
          </div>
        </div>
        <div>
          <h4 className="overline-red mb-4">{t("footer.quick")}</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/offerte" className="hover:text-white transition-colors">{t("nav.offerte")}</Link></li>
            <li><Link to="/afspraak" className="hover:text-white transition-colors">{t("nav.afspraak")}</Link></li>
            <li><Link to="/verhuur" className="hover:text-white transition-colors">{t("nav.verhuur")}</Link></li>
            <li><Link to="/over-ons" className="hover:text-white transition-colors">{t("nav.over")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline-red mb-4">{t("footer.services")}</h4>
          <ul className="space-y-2 text-sm text-zinc-400">
            <li><Link to="/diensten#onderhoud" className="hover:text-white transition-colors">{t("cards.0.title")}</Link></li>
            <li><Link to="/diensten#diagnose" className="hover:text-white transition-colors">{t("cards.1.title")}</Link></li>
            <li><Link to="/diensten#mobiel" className="hover:text-white transition-colors">{t("cards.2.title")}</Link></li>
            <li><Link to="/diensten#keuring" className="hover:text-white transition-colors">{t("cards.3.title")}</Link></li>
            <li><Link to="/diensten#sleep" className="hover:text-white transition-colors">{t("cards.4.title")}</Link></li>
          </ul>
        </div>
        <div>
          <h4 className="overline-red mb-4">{t("footer.contact")}</h4>
          <ul className="space-y-3 text-sm text-zinc-400">
            <li className="flex items-start gap-2"><MapPin size={15} className="mt-0.5 text-[#E11D48] shrink-0" />{GARAGE.address}</li>
            <li><a href={GARAGE.phoneHref} className="flex items-center gap-2 hover:text-white transition-colors"><Phone size={15} className="text-[#E11D48] shrink-0" />{GARAGE.phoneDisplay}</a></li>
            <li><a href={`mailto:${GARAGE.email}`} className="flex items-center gap-2 hover:text-white transition-colors"><Mail size={15} className="text-[#E11D48] shrink-0" />{GARAGE.email}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-800">
        <div className="container-x py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} Milano Worx Autogarage — BTW {GARAGE.btw} — {t("footer.rights")}</span>
          <div className="flex gap-4">
            <Link to="/privacy" data-testid="footer-privacy" className="hover:text-zinc-300 transition-colors">{t("footer.privacy")}</Link>
            <Link to="/voorwaarden" data-testid="footer-terms" className="hover:text-zinc-300 transition-colors">{t("footer.terms")}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
